import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Alert, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import api from '../../api';
import { ProcessoViewModel } from '../../viewmodel/ProcessoViewModel';
import HelpDrawerCronograma from './HelpDrawerCronograma';
import { BsQuestionCircle } from 'react-icons/bs';

interface Destinatario {
  tratamento: string;
  nome: string;
  cargo: string;
  unidade: string;
}

interface EstimativaBanca {
  tipoBanca: string;
  quantidade: number;
  observacoes?: string;
}

interface EstimativaCustoItem {
  categoria: string;
  valorPorPessoaFacial: number;
  valorPorPessoaVirtual: number;
  valorPorPessoaRecursal: number;
  qtdFacial: number;
  qtdVirtual: number;
  qtdRecursal: number;
  bancaFacial: number;
  bancaVirtual: number;
  bancaRecursal: number;
}

interface EstimativaCusto {
  itens: EstimativaCustoItem[];
}

interface CronogramaEvento {
  data: string;
  horario: string;
  atividade: string;
  responsavel: string;
  local: string;
}

interface CronogramaData {
  cidadeUniversitaria: string;
  localData: string;
  orgaoRemetente: string;
  numeroOficio: string;
  destinatarios: Destinatario[];
  assunto: string;
  cronograma: CronogramaEvento[];
  estimativaBancas: EstimativaBanca[];
  nomeCoordenadora: string;
  nomePresidente: string;
}

interface FormData {
  numeroOficio: string;
  destinatarios: Destinatario[];
  estimativaBancas: EstimativaBanca[];
  estimativaCusto: EstimativaCusto;
  nomeCoordenadora: string;
  cargoCoordenadora: string;
  nomePresidente: string;
  cargoPresidente3: string;
}

interface CronogramaPDFProps {
  processoIdProp?: string;
}

const CronogramaPDF: React.FC<CronogramaPDFProps> = ({ processoIdProp }) => {
  const { processoId: processoIdUrl } = useParams<{ processoId: string }>();
  const [processoId, setProcessoId] = useState(processoIdProp || processoIdUrl || '');
  const [processos, setProcessos] = useState<any[]>([]);
  const [cronogramaData, setCronogramaData] = useState<CronogramaData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [valorGlobalPorPessoa, setValorGlobalPorPessoa] = useState(200.00);
  const [showHelpDrawer, setShowHelpDrawer] = useState(false);
  
  const [formData, setFormData] = useState<FormData>({
    numeroOficio: '',
    destinatarios: [{ tratamento: 'Ilmo. Prof. Dr.', nome: '', cargo: '', unidade: '' }],
    estimativaBancas: [{ tipoBanca: 'FACIAL', quantidade: 1, observacoes: '' }],
    estimativaCusto: {
      itens: [
        { categoria: 'Docente', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Estudante de Pós-Graduação', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Estudante de Graduação', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Servidor', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Membro da Sociedade Civil', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Advogado', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Técnico de Banca', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 },
        { categoria: 'Secretário de Banca', valorPorPessoaFacial: 200.00, valorPorPessoaVirtual: 200.00, valorPorPessoaRecursal: 200.00, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: 200.00, bancaVirtual: 200.00, bancaRecursal: 200.00 }
      ]
    },
    nomeCoordenadora: '',
    cargoCoordenadora: 'Coordenadora da Comissão de Heteroidentificação – Técnico Administrativo',
    nomePresidente: '',
    cargoPresidente3: 'Presidente da Comissão de Heteroidentificação'
  });

  useEffect(() => {
    carregarProcessos();
    // Se recebeu processoId via props ou URL, define no estado
    if (processoIdProp || processoIdUrl) {
      setProcessoId(processoIdProp || processoIdUrl || '');
    }
  }, [processoIdProp, processoIdUrl]);

  useEffect(() => {
    if (processoId.trim()) {
      buscarCronograma();
    } else {
      setCronogramaData(null);
    }
  }, [processoId]);

  const carregarProcessos = async () => {
    try {
      const response = await ProcessoViewModel.obterListaDeProcessos(false);
      setProcessos(response.content);
    } catch (err) {
      setError('Erro ao carregar processos');
    }
  };

  const buscarCronograma = async () => {
    if (!processoId.trim()) {
      setError('Por favor, selecione um processo');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const dadosBackend = prepararDadosParaBackend();
      const response = await api.post(`/processos/${processoId}/cronograma/pdf`, dadosBackend);
      setCronogramaData(response.data);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao buscar cronograma');
    } finally {
      setLoading(false);
    }
  };

  const gerarPDF = async () => {
    if (!processoId.trim()) {
      setError('Por favor, selecione um processo');
      return;
    }

    setLoading(true);
    try {
      const dadosBackend = prepararDadosParaBackend();
      const response = await api.post(`/processos/${processoId}/cronograma/generate-pdf`, dadosBackend, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cronograma-${processoId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao gerar PDF');
    } finally {
      setLoading(false);
    }
  };

  const handleDestinatarioChange = (index: number, field: keyof Destinatario, value: string) => {
    const novosDestinatarios = [...formData.destinatarios];
    novosDestinatarios[index] = { ...novosDestinatarios[index], [field]: value };
    setFormData({ ...formData, destinatarios: novosDestinatarios });
  };

  const adicionarDestinatario = () => {
    setFormData({
      ...formData,
      destinatarios: [...formData.destinatarios, { tratamento: 'Ilmo. Prof. Dr.', nome: '', cargo: '', unidade: '' }]
    });
  };

  const removerDestinatario = (index: number) => {
    if (formData.destinatarios.length > 1) {
      const novosDestinatarios = formData.destinatarios.filter((_, i) => i !== index);
      setFormData({ ...formData, destinatarios: novosDestinatarios });
    }
  };

  const atualizarValorGlobal = (novoValor: number) => {
    setValorGlobalPorPessoa(novoValor);
    const novosItens = formData.estimativaCusto.itens.map(item => ({
      ...item,
      valorPorPessoaFacial: novoValor,
      valorPorPessoaVirtual: novoValor,
      valorPorPessoaRecursal: novoValor,
      bancaFacial: novoValor * item.qtdFacial,
      bancaVirtual: novoValor * item.qtdVirtual,
      bancaRecursal: novoValor * item.qtdRecursal
    }));
    setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
  };

  const resetarTabela = () => {
    const itensResetados = [
      { categoria: 'Docente', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Estudante de Pós-Graduação', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Estudante de Graduação', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Servidor', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Membro da Sociedade Civil', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Advogado', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Técnico de Banca', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa },
      { categoria: 'Secretário de Banca', valorPorPessoaFacial: valorGlobalPorPessoa, valorPorPessoaVirtual: valorGlobalPorPessoa, valorPorPessoaRecursal: valorGlobalPorPessoa, qtdFacial: 1, qtdVirtual: 1, qtdRecursal: 1, bancaFacial: valorGlobalPorPessoa, bancaVirtual: valorGlobalPorPessoa, bancaRecursal: valorGlobalPorPessoa }
    ];
    setFormData({ ...formData, estimativaCusto: { itens: itensResetados } });
  };



  const prepararDadosParaBackend = () => {
    return {
      numeroOficio: formData.numeroOficio,
      destinatarios: formData.destinatarios,
      estimativaBancas: formData.estimativaBancas,
      estimativaCusto: {
        itens: formData.estimativaCusto.itens.map(item => ({
          categoria: item.categoria,
          bancaFacial: item.bancaFacial,
          bancaVirtual: item.bancaVirtual,
          bancaRecursal: item.bancaRecursal
        }))
      },
      nomeCoordenadora: formData.nomeCoordenadora,
      cargoCoordenadora: formData.cargoCoordenadora,
      nomePresidente: formData.nomePresidente,
      cargoPresidente3: formData.cargoPresidente3
    };
  };

  return (
    <HelpDrawerCronograma isOpen={showHelpDrawer} onClose={() => setShowHelpDrawer(false)}>
    <div className="container-fluid p-5" style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      <div className="mb-5" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 className="display-6 text-primary fw-light">Gerar Cronograma em PDF</h1>
          <p className="text-muted">Prepara documento para ofício</p>
        </div>
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => setShowHelpDrawer(true)}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}
        >
          <BsQuestionCircle /> Ajuda
        </button>
      </div>

      {error && <Alert variant="danger" className="border-0 shadow-sm">{error}</Alert>}

      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-primary text-white"><strong>Configurações Básicas</strong></Card.Header>
        <Card.Body>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Processo *</Form.Label>
            <Form.Select
              value={processoId}
              onChange={(e) => setProcessoId(e.target.value)}
              className="form-select-lg"
            >
              <option value="">Selecione um processo</option>
              {processos.map(processo => (
                <option key={processo.id} value={processo.id}>
                  {processo.nome} ({processo.identificador}) - {processo.status}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {loading && <Alert variant="info" className="border-0 bg-light text-primary">Carregando cronograma...</Alert>}
          {cronogramaData && (
            <>
              <hr className="my-4" />
              <h5 className="text-secondary mb-3">Cronograma</h5>
              <Table className="table-hover border-0">
                <thead className="table-light">
                  <tr>
                    <th className="border-0 text-secondary">Data</th>
                    <th className="border-0 text-secondary">Horário</th>
                    <th className="border-0 text-secondary">Atividade</th>
                    <th className="border-0 text-secondary">Responsável</th>
                    <th className="border-0 text-secondary">Local</th>
                  </tr>
                </thead>
                <tbody>
                  {cronogramaData.cronograma.map((evento, index) => (
                    <tr key={index}>
                      <td className="border-0">{new Date(evento.data).toLocaleDateString('pt-BR')}</td>
                      <td className="border-0">{evento.horario}</td>
                      <td className="border-0">{evento.atividade}</td>
                      <td className="border-0">{evento.responsavel}</td>
                      <td className="border-0">{evento.local}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>

      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-secondary text-white"><strong>Número do Ofício</strong></Card.Header>
        <Card.Body>
          <Form.Group>
            <Form.Label className="fw-semibold">Número do Ofício *</Form.Label>
            <Form.Control
              type="text"
              value={formData.numeroOficio}
              onChange={(e) => setFormData({ ...formData, numeroOficio: e.target.value })}
              placeholder="Ex: 001/2024"
              className="form-control-lg"
            />
          </Form.Group>
        </Card.Body>
      </Card>

      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-info text-white"><strong>Destinatários</strong></Card.Header>
        <Card.Body>
          {formData.destinatarios.map((dest, index) => (
            <Row key={index} className="mb-3">
              <Col md={3}>
                <Form.Control
                  type="text"
                  value={dest.tratamento}
                  onChange={(e) => handleDestinatarioChange(index, 'tratamento', e.target.value)}
                  placeholder="Tratamento"
                />
              </Col>
              <Col md={3}>
                <Form.Control
                  type="text"
                  value={dest.nome}
                  onChange={(e) => handleDestinatarioChange(index, 'nome', e.target.value)}
                  placeholder="Nome"
                />
              </Col>
              <Col md={3}>
                <Form.Control
                  type="text"
                  value={dest.cargo}
                  onChange={(e) => handleDestinatarioChange(index, 'cargo', e.target.value)}
                  placeholder="Cargo"
                />
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  value={dest.unidade}
                  onChange={(e) => handleDestinatarioChange(index, 'unidade', e.target.value)}
                  placeholder="Unidade"
                />
              </Col>
              <Col md={1}>
                <Button variant="outline-danger" size="sm" onClick={() => removerDestinatario(index)}>
                  ✕
                </Button>
              </Col>
            </Row>
          ))}
          <Button variant="outline-primary" size="sm" onClick={adicionarDestinatario}>
            + Adicionar Destinatário
          </Button>
        </Card.Body>
      </Card>



      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-warning text-dark"><strong>Estimativa de Bancas</strong></Card.Header>
        <Card.Body>
          {formData.estimativaBancas.map((banca, index) => (
            <Row key={index} className="mb-3">
              <Col md={4}>
                <Form.Select
                  value={banca.tipoBanca}
                  onChange={(e) => {
                    const novasBancas = [...formData.estimativaBancas];
                    novasBancas[index] = { ...novasBancas[index], tipoBanca: e.target.value };
                    setFormData({ ...formData, estimativaBancas: novasBancas });
                  }}
                >
                  <option value="FACIAL">FACIAL</option>
                  <option value="VIRTUAL">VIRTUAL</option>
                  <option value="RECURSAL">RECURSAL</option>
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="number"
                  value={banca.quantidade}
                  onChange={(e) => {
                    const novasBancas = [...formData.estimativaBancas];
                    novasBancas[index] = { ...novasBancas[index], quantidade: Number(e.target.value) };
                    setFormData({ ...formData, estimativaBancas: novasBancas });
                  }}
                  placeholder="Quantidade"
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  value={banca.observacoes || ''}
                  onChange={(e) => {
                    const novasBancas = [...formData.estimativaBancas];
                    novasBancas[index] = { ...novasBancas[index], observacoes: e.target.value };
                    setFormData({ ...formData, estimativaBancas: novasBancas });
                  }}
                  placeholder="Observações"
                />
              </Col>
              <Col md={1}>
                <Button 
                  variant="outline-danger" 
                  size="sm" 
                  onClick={() => {
                    if (formData.estimativaBancas.length > 1) {
                      const novasBancas = formData.estimativaBancas.filter((_, i) => i !== index);
                      setFormData({ ...formData, estimativaBancas: novasBancas });
                    }
                  }}
                >
                  ✕
                </Button>
              </Col>
            </Row>
          ))}
          <Button 
            variant="outline-primary" 
            size="sm" 
            onClick={() => {
              setFormData({
                ...formData,
                estimativaBancas: [...formData.estimativaBancas, { tipoBanca: 'FACIAL', quantidade: 1, observacoes: '' }]
              });
            }}
          >
            + Adicionar Banca
          </Button>
        </Card.Body>
      </Card>

      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-success text-white"><strong>Estimativa de Custo</strong></Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Aplicar Valor Global para Todas as Colunas (R$)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={valorGlobalPorPessoa}
                  onChange={(e) => atualizarValorGlobal(Number(e.target.value))}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="d-flex align-items-end">
              <Button variant="outline-secondary" size="sm" onClick={resetarTabela}>
                🔄 Resetar Tabela
              </Button>
            </Col>
          </Row>
          
          <Table className="table-hover border-0">
            <thead>
              <tr>
                <th rowSpan={2} className="border-0 text-secondary bg-light">Categoria</th>
                <th colSpan={2} className="border-0 text-center text-white fw-bold" style={{backgroundColor: '#0d6efd'}}>Facial</th>
                <th colSpan={2} className="border-0 text-center text-white fw-bold" style={{backgroundColor: '#20c997'}}>Virtual</th>
                <th colSpan={2} className="border-0 text-center text-white fw-bold" style={{backgroundColor: '#fd7e14'}}>Recursal</th>
                <th rowSpan={2} className="border-0 text-secondary bg-light">Ações</th>
              </tr>
              <tr>
                <th className="border-0 text-dark small" style={{backgroundColor: '#e3f2fd'}}>Valor/Pessoa (R$)</th>
                <th className="border-0 text-dark small" style={{backgroundColor: '#e3f2fd'}}>Qtd</th>
                <th className="border-0 text-dark small" style={{backgroundColor: '#e0f2f1'}}>Valor/Pessoa (R$)</th>
                <th className="border-0 text-dark small" style={{backgroundColor: '#e0f2f1'}}>Qtd</th>
                <th className="border-0 text-dark small" style={{backgroundColor: '#fff3e0'}}>Valor/Pessoa (R$)</th>
                <th className="border-0 text-dark small" style={{backgroundColor: '#fff3e0'}}>Qtd</th>
              </tr>
            </thead>
            <tbody>
              {formData.estimativaCusto.itens.map((item, index) => (
                <tr key={index}>
                  <td className="border-0 fw-semibold bg-light">{item.categoria}</td>
                  <td className="border-0" style={{backgroundColor: '#e3f2fd'}}>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={item.valorPorPessoaFacial}
                      className="border-0"
                      style={{backgroundColor: '#bbdefb'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const valor = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          valorPorPessoaFacial: valor,
                          bancaFacial: valor * novosItens[index].qtdFacial
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0" style={{backgroundColor: '#e3f2fd'}}>
                    <Form.Control
                      type="number"
                      value={item.qtdFacial}
                      className="border-0"
                      style={{backgroundColor: '#bbdefb'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const qtd = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          qtdFacial: qtd,
                          bancaFacial: novosItens[index].valorPorPessoaFacial * qtd
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0" style={{backgroundColor: '#e0f2f1'}}>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={item.valorPorPessoaVirtual}
                      className="border-0"
                      style={{backgroundColor: '#b2dfdb'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const valor = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          valorPorPessoaVirtual: valor,
                          bancaVirtual: valor * novosItens[index].qtdVirtual
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0" style={{backgroundColor: '#e0f2f1'}}>
                    <Form.Control
                      type="number"
                      value={item.qtdVirtual}
                      className="border-0"
                      style={{backgroundColor: '#b2dfdb'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const qtd = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          qtdVirtual: qtd,
                          bancaVirtual: novosItens[index].valorPorPessoaVirtual * qtd
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0" style={{backgroundColor: '#fff3e0'}}>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={item.valorPorPessoaRecursal}
                      className="border-0"
                      style={{backgroundColor: '#ffcc80'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const valor = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          valorPorPessoaRecursal: valor,
                          bancaRecursal: valor * novosItens[index].qtdRecursal
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0" style={{backgroundColor: '#fff3e0'}}>
                    <Form.Control
                      type="number"
                      value={item.qtdRecursal}
                      className="border-0"
                      style={{backgroundColor: '#ffcc80'}}
                      onChange={(e) => {
                        const novosItens = [...formData.estimativaCusto.itens];
                        const qtd = Number(e.target.value);
                        novosItens[index] = { 
                          ...novosItens[index], 
                          qtdRecursal: qtd,
                          bancaRecursal: novosItens[index].valorPorPessoaRecursal * qtd
                        };
                        setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                      }}
                    />
                  </td>
                  <td className="border-0 bg-light">
                    <Button 
                      variant="outline-danger" 
                      size="sm" 
                      onClick={() => {
                        if (formData.estimativaCusto.itens.length > 1) {
                          const novosItens = formData.estimativaCusto.itens.filter((_, i) => i !== index);
                          setFormData({ ...formData, estimativaCusto: { itens: novosItens } });
                        }
                      }}
                    >
                      ✕
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-dark text-white"><strong>Assinaturas</strong></Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome da Coordenadora</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.nomeCoordenadora}
                  onChange={(e) => setFormData({ ...formData, nomeCoordenadora: e.target.value })}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cargo da Coordenadora</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.cargoCoordenadora}
                  onChange={(e) => setFormData({ ...formData, cargoCoordenadora: e.target.value })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome do Presidente</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.nomePresidente}
                  onChange={(e) => setFormData({ ...formData, nomePresidente: e.target.value })}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cargo do Presidente</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.cargoPresidente3}
                  onChange={(e) => setFormData({ ...formData, cargoPresidente3: e.target.value })}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div className="text-center mt-5">
        <Button 
          variant="primary" 
          size="lg" 
          onClick={gerarPDF} 
          disabled={loading || !processoId}
          className="px-5 py-3 shadow-sm border-0"
          style={{borderRadius: '8px'}}
        >
          {loading ? 'Gerando...' : '📄 Gerar PDF'}
        </Button>
      </div>
    </div>
    </HelpDrawerCronograma>
  );
};

export default CronogramaPDF;